@if (readonly && value) {
  <div class="input-container" [style.width]="width">
    <div class="header">
      <div class="label-readonly">{{ label }}</div>
    </div>

    <input
      type="password"
      class="input-readonly"
      [disabled]="true"
      [(ngModel)]="value"
      [placeholder]="placeholder"
    >
  </div>
} @else {
  <div class="input-container" [style.width]="width">
    <div class="header">
      <div class="label">{{ label }}</div>
    </div>

    <div
      class="input-wrapper"
      [class]="{ 'error': validationError || displayValidationError, 'check': checkedState, 'warn': warningState }"
    >
      <input
        class="input"
        [type]="type"
        [disabled]="isDisabled || disabled"
        [(ngModel)]="value"
        (blur)="onTouched()"
      >

      <i
        class="input-icon icon"
        placement="bottom"
        [ngbTooltip]="warningTooltipMessage"
        [class]="{
          'ic-info-circle-16': validationError || warningState || displayValidationError,
          'ic-checkmark-circle-16': checkedState,
          'icon-close-to-side': hidePasswordIcon
        }">
      </i>

      <i
        [class]="'show-password-icon icon ' + showPasswordIconClass"
        [hidden]="hidePasswordIcon"
        (click)="passwordVisible = !passwordVisible"
      ></i>
    </div>

    @if (helperText) {
      <div class="helper" [class]="{ 'error': validationError }">{{ helperText }}</div>
    }

    @if (shouldShowErrors && displayValidationError) {
      <app-validation-error [customErrors]="customErrors"></app-validation-error>
    }
  </div>
}

